import { connect } from "react-redux";
import Login from "../../components/login/login";
import sessionExpiredTop from "../../assets/images/session-expired.svg";
import { setTokenHeader, getCards, init } from "../../actions/services";

import {
  Stages,
  populateCards,
  setError,
  setIsConnected,
  selectCard,
  callGoogleAnalytics,
  setStage,
  setLogout,
} from "../../actions/actions";

let customError = "";

const mapDispatchToProps = (dispatch) => {
  return {
    onLoginSuccess: (token) => {
      setTimeout(() => {
        let text = window.settings.provider.labels.sessionExpiredText;
        let okText = window.settings.provider.labels.sessionExpiredOkText;
        let cancelText =
          window.settings.provider.labels.sessionExpiredCancelText;
        dispatch(callGoogleAnalytics(window.settings.ga.pages.sessionTimeOut));
        dispatch(
          setLogout(
            null,
            null,
            text,
            sessionExpiredTop,
            okText,
            cancelText,
            true
          )
        );
      }, 1000 * 60 * 14);
      setTokenHeader(token);
      dispatch(setIsConnected(true));

      init()
        .then((response) => {
          //   dispatch(setLoader(true));
          getCards()
            .then((cardsResponse) => {
              if (
                cardsResponse.data.statusCode != 1 &&
                cardsResponse.data.statusCode != -1 &&
                cardsResponse.data.statusCode != 69
              ) {
                customError = cardsResponse;
                throw new Error(cardsResponse);
              }

              dispatch(setError(null));
              if (
                cardsResponse.data.result != null &&
                cardsResponse.data.result.cards != undefined
              ) {
                dispatch(populateCards(cardsResponse.data.result.cards));
                dispatch(
                  selectCard(cardsResponse.data.result.cards[0].last4Digits)
                );
                dispatch(setStage(Stages.cards));
              } else {
                customError = cardsResponse;
                throw new Error(cardsResponse);
              }
            })
            .catch((error) => {
              if (customError != "") {
                error.response = customError;
                let text = "אירעה שגיאה";
                let status = error.response.status;
                if (error.response.data.statusDescription != null)
                  text = error.response.data.statusDescription;
                if (error.response.data.statusCode != 1)
                  status = error.response.data.statusCode;

                dispatch(setError(status, text));
              } else {
                if (error.response) {
                  dispatch(
                    setError(error.response.status, error.response.data)
                  );
                } else if (error.message) {
                  if (error.message == "Network Error") {
                    error.message = "שגיאת רשת - השירות אינו זמין";
                  }
                  error.response = {};
                  error.response.data = {};
                  error.response.data = error.message;
                  dispatch(setError(503, error.message));
                }
              }
              //   dispatch(setLoader(false));
              dispatch(
                callGoogleAnalytics(
                  window.settings.ga.pages.cardsError,
                  error.response.data
                )
              );
            })
            .then(() => {
              //   dispatch(setLoader(false));
            });
        })
        .catch((error) => {
          if (!error.response) {
            error.response = {};
            error.response.data = {};
            if (!error.response.status) error.response.status = 503;
          }

          dispatch(
            callGoogleAnalytics(
              window.settings.ga.pages.cardsError,
              error.response.data
            )
          );
          dispatch(setError(error.response.status, error.response.data));
          //   dispatch(setLoader(false));
        });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    error: state.session.app.error,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/login/Login.js